import React, { useState, useEffect } from 'react';

export default function SubSectionEditForm({ type, data, onSave, onCancel, loading = false }) {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (data && type) {
      switch (type) {
        case 'contact':
          setFormData({
            contact_numbers: data.contact_numbers || [],
            email: data.email || '',
            website: data.website || '',
            pincode: data.pincode || '',
          });
          break;
        case 'discount':
          setFormData({
            discount_text: data.active_discount?.discount_text || '',
            fixed_discount: data.active_discount?.fixed_discount || '',
            customer_discount: data.active_discount?.customer_discount || '',
            company_commission: data.active_discount?.company_commission || '',
          });
          break;
        case 'timings':
          setFormData(data.shop_timings || {});
          break;
        case 'gallery':
          setFormData({
            gallery_images: data.gallery_images || [],
          });
          break;
        default:
          setFormData({});
      }
    }
  }, [data, type]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleContactNumbersChange = (value) => {
    const numbers = value.split(',').map(num => num.trim()).filter(num => num);
    setFormData(prev => ({
      ...prev,
      contact_numbers: numbers
    }));
  };

  const handleTimingChange = (day, field, value) => {
    setFormData(prev => ({
      ...prev,
      [day]: {
        ...prev[day],
        [field]: value
      }
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const renderContactForm = () => (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Contact Numbers (comma separated)
        </label>
        <input
          type="text"
          value={formData.contact_numbers?.join(', ') || ''}
          onChange={(e) => handleContactNumbersChange(e.target.value)}
          placeholder="e.g., 1234567890, 0987654321"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Email
        </label>
        <input
          type="email"
          value={formData.email || ''}
          onChange={(e) => handleInputChange('email', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Website
        </label>
        <input
          type="url"
          value={formData.website || ''}
          onChange={(e) => handleInputChange('website', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Pincode
        </label>
        <input
          type="text"
          value={formData.pincode || ''}
          onChange={(e) => handleInputChange('pincode', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
  );

  const renderDiscountForm = () => (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Discount Text
        </label>
        <input
          type="text"
          value={formData.discount_text || ''}
          onChange={(e) => handleInputChange('discount_text', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Fixed Discount (%)
          </label>
          <input
            type="number"
            value={formData.fixed_discount || ''}
            onChange={(e) => handleInputChange('fixed_discount', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Customer Discount (%)
          </label>
          <input
            type="number"
            value={formData.customer_discount || ''}
            onChange={(e) => handleInputChange('customer_discount', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Company Commission (%)
          </label>
          <input
            type="number"
            value={formData.company_commission || ''}
            onChange={(e) => handleInputChange('company_commission', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
    </div>
  );

  const renderTimingsForm = () => {
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    
    return (
      <div className="space-y-3">
        {days.map(day => (
          <div key={day} className="flex items-center space-x-4">
            <div className="w-20 text-sm font-medium capitalize">{day.slice(0, 3)}</div>
            <div className="flex space-x-2">
              <input
                type="time"
                value={formData[day]?.open || ''}
                onChange={(e) => handleTimingChange(day, 'open', e.target.value)}
                className="px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <span className="text-gray-500">to</span>
              <input
                type="time"
                value={formData[day]?.close || ''}
                onChange={(e) => handleTimingChange(day, 'close', e.target.value)}
                className="px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderGalleryForm = () => (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Gallery Images
        </label>
        <input
          type="file"
          multiple
          accept="image/*"
          onChange={(e) => {
            // Handle file upload logic here
            console.log('Files selected:', e.target.files);
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="grid grid-cols-4 gap-2">
        {formData.gallery_images?.map((img, index) => (
          <div key={index} className="relative">
            <img
              src={img.image}
              alt={`Gallery ${index + 1}`}
              className="w-full h-20 object-cover rounded"
            />
            <button
              type="button"
              onClick={() => {
                const newImages = formData.gallery_images.filter((_, i) => i !== index);
                setFormData(prev => ({ ...prev, gallery_images: newImages }));
              }}
              className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );

  const getFormTitle = () => {
    switch (type) {
      case 'contact': return 'Edit Contact Information';
      case 'discount': return 'Edit Discount Settings';
      case 'timings': return 'Edit Shop Timings';
      case 'gallery': return 'Edit Gallery Images';
      default: return 'Edit';
    }
  };

  const renderForm = () => {
    switch (type) {
      case 'contact': return renderContactForm();
      case 'discount': return renderDiscountForm();
      case 'timings': return renderTimingsForm();
      case 'gallery': return renderGalleryForm();
      default: return <div>Unknown form type</div>;
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        {renderForm()}
        <div className="flex justify-end space-x-2 pt-4">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="rounded border px-4 py-2 text-gray-700 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </form>
    </div>
  );
}